<template>
<transition>
  <div class="overlay-container" :class="viewOverlay ? 'with-overlay' : ''"
  :style="`--data-message: '${dataMessage}; 
          --data-position:${dataPosition};
          --data-z-index: ${dataActiveIndex}
  `">
    <div class="progress-placement">
    <div class="progress">
      <div class="indeterminate"></div>
    </div>
  </div>
</div>
</transition>
</template>
<script>
export default {
  props:{
    dataPosition:{
      type: String, 
      default: 'absolute'
    },
    dataActiveIndex:{
      type: [String, Number],
      default: 9, 
    },
    dataMessage:{
      type: String,
      default:'Loading Please Wait'
    },
    viewOverlay: {
      type: Boolean,
      default:true
    }
  },
  name: 'LoadingProgress',
}
</script>
<style scoped lang="scss">
.overlay-container {
  &.with-overlay {
    background-color: rgba(0, 0, 0, 0.27);
  }
    position: var(--data-position, absolute);;
    left: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    z-index: var(--data-z-index, 9);
    top: 0;

    .progress-placement {
      position: absolute;
      left: 50%;
      width: 80%;
      max-width: 300px;
      transform: translate(-50%, -50%);
      top: 50%;
      &::before {
          content:var(--data-message);
          font-weight: 500;
          color: white;
          letter-spacing: 1px;
      }
    }
}

</style>